import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Bell } from "lucide-react";

const MobileNotifications = () => {
  const [list, setList] = useState([]);
  useEffect(() => { api.get("/notifications").then((r) => setList(r.data)).catch(() => {}); }, []);
  return (
    <div className="px-4 pt-4 pb-6" data-testid="mobile-notifs-page">
      <h2 className="font-display text-xl text-[#1B2C5A] flex items-center gap-2"><Bell className="w-5 h-5 text-[#9DCD3F]" /> Notifications</h2>
      <p className="text-xs text-[#475569]">Latest academy-wide announcements.</p>
      {list.length === 0 ? (
        <div className="mt-6 text-center text-sm text-[#475569] py-8 border border-dashed border-[#E2E8F0] rounded-xl">No notifications yet.</div>
      ) : (
        <ul className="mt-4 space-y-2">
          {list.map((n) => (
            <li key={n.id} className="p-3 rounded-xl bg-white border border-[#E2E8F0]" data-testid={`notif-${n.id}`}>
              <div className="flex items-center justify-between gap-3 mb-1">
                <div className="font-display text-[#1B2C5A] truncate">{n.title}</div>
                <span className="text-[10px] uppercase tracking-widest text-[#9DCD3F]">{n.audience}</span>
              </div>
              <p className="text-sm text-[#475569] whitespace-pre-line leading-relaxed">{n.body}</p>
              <div className="text-[11px] text-[#475569] mt-2">{n.created_by_name} · {new Date(n.created_at).toLocaleString()}</div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default MobileNotifications;
